<template>
  <div class="container">
    <ul v-if="detail != ''">
      <li>
        <label>批次编号：</label>
        <p>{{ detail.no }}</p>
      </li>
      <li>
        <label>出库日期： </label>
        <p>{{ detailVal.out_date }}</p>
      </li>
      <li>
        <label>操作人： </label>
        <p>{{ detailVal.user_name }}</p>
      </li>
      <li>
        <label>操作时间： </label>
        <p>{{ detailVal.create_time }}</p>
      </li>
    </ul>
    <table>
      <thead>
        <th>网点设备</th>
        <th>商品名称</th>
        <th>商品图</th>
        <th>出库类型</th>
        <th>出库数量</th>
        <th>收货数量</th>
      </thead>
      <tbody>
        <tr v-for="(item, index) in list" :key="index">
          <td>{{ item.device_name }}</td>
          <td>{{ item.brand_name }}</td>
          <td>
            <img :src="item.imageUrl.url_thumb" alt="" />
          </td>
          <td>
            <p v-show="item.out_type == 1">补货</p>
            <p v-show="item.out_type == 2">美陈</p>
          </td>
          <td>{{ item.num }}</td>
          <td>{{ item.real_num }}</td>
        </tr>
      </tbody>
    </table>
    <div class="operation" v-show="detail.status == 3">
      <a-button type="primary" @click="auditPagePass">
        审核通过
      </a-button>
      <a-button type="danger" @click="auditPageReject">
        审核驳回
      </a-button>
    </div>
    <!-- 驳回 -->
    <section class="dialogsBox" v-show="rejectIsShow">
      <div>
        <h3>驳回</h3>
        <ul>
          <li>
            <label><i>*</i>驳回原因：</label>
            <a-textarea
              v-model="reason"
              placeholder="请输入驳回原因"
              style="width: 300px"
            />
          </li>
        </ul>
        <div>
          <a-button @click="rejectIsShow = false">取消</a-button>
          <a-button type="primary" @click="rejectSure">确认</a-button>
        </div>
      </div>
    </section>
    <!-- 驳回 end -->
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      detail: "",
      list: "",
      rejectIsShow: false,
      reason: ""
    };
  },
  props: {
    detailVal: {}
  },
  watch: {
    detailVal() {
      this.getDetail();
    }
  },
  mounted() {
    if (this.detailVal != undefined) {
      this.getDetail();
    }
  },
  methods: {
    getDetail() {
      this.detail = this.detailVal;
      let url =
        this.httpsBasic.url +
        this.httpsBasic.equipment +
        "Project_out_order/getProjectOutOrderDetail";
      let params = {
        token: window.localStorage.getItem("xnwfPcToken"),
        project_out_order_id: this.detailVal.id
      };
      axios.post(url, params).then(res => {
        if (res.data.code == 200) {
          this.list = res.data.data;
          // console.log(this.detail);
        }
      });
    },
    auditPagePass() {
      let _this = this;
      this.$confirm({
        title: "审核总仓发货单",
        content: "一旦确定，双方库存进行自动校正，是否确认操作!",
        cancelText: "取消",
        okText: "确认",
        onOk() {
          _this.orderPassOperation();
        },
        onCancel() {}
      });
    },
    orderPassOperation() {
      let url =
        this.httpsBasic.url +
        this.httpsBasic.equipment +
        "Project_out_order/checkDiff";
      axios
        .post(url, {
          token: window.localStorage.getItem("xnwfPcToken"),
          project_out_order_id: this.detail.id
        })
        .then(res => {
          if (res.data.code == 200) {
            this.$message.success("审核成功");
          } else {
            this.$message.info(res.data.message);
          }
          this.$emit("hideIsDetail", true);
        })
        .catch(err => {});
    },
    auditPageReject() {
      this.rejectIsShow = true;
    },
    rejectSure() {
      if (this.reason != "" && this.reason != null) {
        this.rejectIsShow = false;
        let url =
          this.httpsBasic.url +
          this.httpsBasic.equipment +
          "Project_out_order/checkReject";
        axios
          .post(url, {
            token: window.localStorage.getItem("xnwfPcToken"),
            project_out_order_id: this.detail.id,
            reason: this.reason
          })
          .then(res => {
            if (res.data.code == 200) {
              this.$message.success("已驳回");
              this.$emit("hideIsDetail", true);
            } else {
              this.$message.info(res.data.message);
            }
          })
          .catch(err => {});
      } else {
        this.$message.info("请填写驳回原因");
      }
    }
  }
};
</script>
<style lang="less" scoped>
.container {
  position: relative;
  > ul {
    margin-top: 30px;
    > li {
      margin-bottom: 10px;
      p,
      label {
        display: inline-block;
        font-size: 14px;
        line-break: 20px;
      }
    }
  }
  table {
    td,
    th {
      border: 1px solid #ccc;
      padding: 4px 6px;
    }
    tr {
      img {
        height: 30px;
        width: 30px;
      }
    }
  }
  .operation {
    position: absolute;
    right: 30px;
    top: 20px;
    display: flex;
    flex-direction: column;
    button {
      margin-bottom: 16px;
    }
  }
}
</style>
